export const types = {
    STOP: 'STOP',
};
